/* Package JSON Import will be here */
import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { bindActionCreators } from "redux";
import { Button } from "antd";
import { includes } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { changeCaseQuantity, removeAllChangedProductFromOrderReducer } from "reducers/orders";
import { ButtonSpinner } from "components/Spinner";
import OrderQtyModal from "components/orders/OrderQtyModal";
import Constants from "utilities/appConstants";
import { checkEligibleForFoc, errorToast } from "utilities/utils";
import modalConfirmationHook from "hooks/modalConfirmationHook";
import { changeFocStatus } from "reducers/common";
/* Project Import will be here */

class QuantityCounter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenOrderQtyModal: false
    };
  }

  increment = (e) => {
    e.stopPropagation();
    if (this.checkForFocValidation()) {
      let currentCaseCount = this.props.orders.data[this.props.product.ProductId].case_count;
      let currentCaseCountInPiece = currentCaseCount * this.props.product.ConversionQty;
      let totalQty = currentCaseCountInPiece + (this.props.orders.data[this.props.product.ProductId].count);
      let case_count = currentCaseCount;

      /* Check for isEnableMinOrderQty logic */
      if (this.props.appSettings.isEnableMinOrderQty && this.props.product.MinORDQty !== 0) {
        /* If the added count of the product is === 0 then directly add the MinOrderQty value */
        if (totalQty === 0) {
          let caseMiniumQty = (this.props.product.MinORDQty > this.props.product.ConversionQty)
            ?
            ~~(this.props.product.MinORDQty / this.props.product.ConversionQty) + (((this.props.product.MinORDQty / this.props.product.ConversionQty) % 1) > 0 ? 1 : 0)
            :
            1;

          case_count = currentCaseCount + caseMiniumQty;
        }

        /* Else if check for it should not exceed the MaxOrderQty value */
        else if ((totalQty + this.props.product.ConversionQty) > this.props.product.MaxORDQty && this.props.product.MaxORDQty !== 0) {
          errorToast({ content: this.props.translate("order.minOrderQty.validationMsg", { count: this.props.product.MaxORDQty }) });
        }
        else {
          if (this.props.product.MaxORDQty === 0 || totalQty <= this.props.product.MaxORDQty)
            case_count = currentCaseCount + 1;
          else
            errorToast({ content: this.props.translate("order.minOrderQty.validationMsg", { count: this.props.product.MaxORDQty }) });
        }
      }

      /* If isEnableMinOrderQty is set to false do not check any conditions directly increment the case count to +1 */
      else {
        case_count = currentCaseCount + 1;
      }

      /* Save updated count */
      this.changeUpdatedCaseQty(case_count);
    }
  };

  decrement = (e) => {
    e.stopPropagation();

    if (this.checkForFocValidation()) {
      let case_count = 0;
      let currentCaseCount = this.props.orders.data[this.props.product.ProductId].case_count;
      let currentCaseCountInPiece = currentCaseCount * this.props.product.ConversionQty;
      let totalQty = currentCaseCountInPiece - (this.props.orders.data[this.props.product.ProductId].count);

      /* Check for isEnableMinOrderQty logic */
      if ((this.props.appSettings.isEnableMinOrderQty && this.props.product.MinORDQty !== 0) && totalQty === this.props.product.MinORDQty)
        case_count = 0;
      else
        case_count = (this.props.product.MinORDQty > (totalQty - this.props.product.ConversionQty)) ? 0 : (currentCaseCount - 1);

      /* Save updated count */
      this.changeUpdatedCaseQty(case_count);
    }
  };

  /* Save updated count */
  changeUpdatedCaseQty = (updatedCount) => {
    if (updatedCount >= 0 && updatedCount <= 9999) {

      /* Check for qty 0 and from cart */
      if (this.checkForZeroQtyAndCartPage(updatedCount)) {
        this.props.zeroCallback(this.props.product.ProductId);
      }
      else {
        this.props.actions.changeCaseQuantity({
          case_count: updatedCount,
          product_id: this.props.product.ProductId,
          caseChange: true
        });
      }
    }
  }

  /* Check for qty 0 and from cart */
  checkForZeroQtyAndCartPage = (caseCount) => {
    const currentPieceCount = this.props.orders.data[this.props.product.ProductId].count
    const productInCart = includes(this.props.cart.ids, this.props.product.ProductId);
    if (this.props.zeroCallback && productInCart && caseCount === 0 && currentPieceCount === 0)
      return true;
    else
      return false;
  }

  checkForFocValidation = () => {
    if (this.props.appSettings.isEnableFoc) {
      if (checkEligibleForFoc(this.props.orders, !this.props.product.IsSaleable)) {
        return true;
      }
      else {
        /* Check for if any products added in the cart */
        if (this.props.cart.ids.length <= 0) {
          /* Ask for clear the added products in the local */
          modalConfirmationHook(this.props.translate("common.alerts.confirmation.removedAddedFocProductInLocalStoreConfirmationTitle"),
            this.props.translate,
            (() => {
              this.props.actions.removeAllChangedProductFromOrderReducer();
              this.props.actions.changeFocStatus(false);
            }));
        }
        else {
          errorToast({
            content: this.props.translate("products.foc.focRequestValidation")
          });
        }

        return false;
      }
    }
    else {
      return true;
    }
  }

  onQtyChanged = (value) => {
    if (value >= 0 && value <= 9999 && this.checkForFocValidation()) {
      /* Check for qty 0 and from cart */
      if (this.checkForZeroQtyAndCartPage(value)) {
        this.props.zeroCallback(this.props.product.ProductId);
      }
      else {
        this.props.actions.changeCaseQuantity({
          case_count: Number(value),
          product_id: this.props.product.ProductId,
          caseChange: true
        });
      }
    }
  };

  openOrderQtyModal = () => {
    this.setState({ isOpenOrderQtyModal: true });
  }

  closeOrderQtyModal = () => {
    this.setState({ isOpenOrderQtyModal: false });
  }

  render() {
    const { orders, product, appSettings } = this.props;
    const disableButtons = ((appSettings.isRestrictSIHProducts && product.SIH === 0) || this.props.isDisable);

    return (
      <React.Fragment>
        {(!orders.isLoading && (product.IsFree ? true : orders.data[product.ProductId])) ? (
          <div className="d-flex align-items-center">
            {product.IsFree ? (
              <div className="product-quantity d-flex align-items-center">
                <div className="card-quantity-input">
                  <p className="m-auto">{product.caseQTY}</p>
                </div>
              </div>
            ) : (
              <div className="product-quantity d-flex align-items-center">
                <Button className={disableButtons ? "product-qul-disabled" : "product-qul"}
                  icon={<i className="icon-minus" />}
                  size="small"
                  onClick={this.decrement}
                  disabled={disableButtons}
                />
                <div className="card-quantity-input">
                  <Button
                    type="text"
                    size="small"
                    onClick={this.openOrderQtyModal}
                    disabled={disableButtons}
                  >
                    {orders.data[product.ProductId].case_count}
                  </Button>
                </div>
                <Button className={disableButtons ? "product-qul-disabled" : "product-qul"}
                  icon={<span className="card-plus-sign">+</span>}
                  size="small"
                  onClick={this.increment}
                  disabled={disableButtons}
                />
              </div>
            )}
          </div>)
          :
          <div className="loding-spinner-div">{orders.isLoading && <ButtonSpinner />}</div>
        }

        {this.state.isOpenOrderQtyModal &&
          <OrderQtyModal
            closeOrderQtyModal={this.closeOrderQtyModal}
            onQtyChanged={this.onQtyChanged}
            isShowOrderQtyModal={this.state.isOpenOrderQtyModal}
            orders={orders}
            product={product}
            appSettings={appSettings}
            pageType={Constants.CASE_QTY}
          />
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    cart: state.cart,
    appSettings: state.appSettings,
    translate: getTranslate(state.locale)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      changeCaseQuantity,
      removeAllChangedProductFromOrderReducer,
      changeFocStatus
    }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuantityCounter);